import { dispatchCustomEvent } from '@opten/events/dispatch-custom-event';
import { getTransitionEndEventName } from '../get-transition-end-event-name';

const transitionEndEventName = getTransitionEndEventName();

export function addTransitionEndListener(
	element: Element,
	callback: () => void,
	fallbackDuration = 0,
	remove = true
): void {
	let called = false;
	const listener = (event: Event) => {
		called = true;
		if (remove) {
			element.removeEventListener(transitionEndEventName as string, listener);
		}
		callback();
	};

	if (transitionEndEventName === false) {
		setTimeout(() => {
			callback();
		}, fallbackDuration);
	} else {
		element.addEventListener(transitionEndEventName, listener);
		// https://github.com/twbs/bootstrap/blob/v4.0.0/js/src/util.js#L49
		if (fallbackDuration) {
			setTimeout(() => {
				if (!called) {
					dispatchCustomEvent(element, transitionEndEventName);
				}
			}, fallbackDuration);
		}
	}
}
